// eslint-disable import/prefer-default-export

/**
 * When true, authenticated main app areas show a blur overlay over module content.
 * Layout, header, and side navigation remain available and interactive.
 * Set to false when dashboard, organisation, and admin modules are ready for release.
 */
export default function isMainModulesUnderConstruction() {
  if (process.env.NODE_ENV === 'development') {
    return false;
  }
  return true;
}

/**
 * PayPal /purchase is enabled for local development only (`npm start`).
 * Disabled on staging and production builds.
 */
export function isPurchaseEnabled() {
  if (process.env.NODE_ENV === 'development') return true;
  return String(process.env.REACT_APP_ENABLE_PURCHASE || '').toLowerCase() === 'true';
}
